import React from "react";
import compose from "recompose/compose";
import branch from "recompose/branch";
import withIsInStockAlertEnabled from "./withIsInStockAlertEnabled";
import withEnsureLoggedIn from "theme/modules/User/helpers/withEnsureLoggedIn";
import { FormattedMessage } from "react-intl";
import withInStockAlertMutations from "./withInStockAlertMutations";
import withIsSubscribedToInStockAlert from "./withIsSubscribedToInStockAlert";

const EnhanceSubscribeToInStockAlert = () =>
  compose(
    withIsInStockAlertEnabled(),
    branch(
      (props) => props.inStockAlert.isFeatureActive,
      (BaseComponent) => BaseComponent,
      () => () => null
    ),
    withEnsureLoggedIn({
      message: (
        <FormattedMessage
          id="modules.SubscribeToInStockAlert.needLogin"
          defaultMessage="You must log in before subscribing to in-stock notifications."
        />
      ),
    }),
    withIsSubscribedToInStockAlert(),
    withInStockAlertMutations()
  );

export default EnhanceSubscribeToInStockAlert;
